export default "__VITE_ASSET__SYmqCkey__"